module.exports = __webpack_public_path__ + "static/banner-desktop-f7f0548329b56c1259a96ead00ff7f56.png";